// extracted by mini-css-extract-plugin
export default {"button":"VR_button__VsddA"};